import React from "react"

const DougVetsch = (
  <>
  <h4>North Idaho Regional Chair</h4>
    <p>
    Doug Vetsch served 7 years active duty and 20 years reserve duty. Served on USS Tinosa SSN 606 based at Subase Groton, CT. Served as a Navy Civilian for 27 years and retiring at the Acoustic Research Detachment (ARD) Bayview, ID in 2018. At ARD, served as the Guidance Navigation and Control Engineer on the Large Scale Vehicle 1 Kokanee, Seawolf Class Model and the Large Scale Vehicle 2, Virginia Class Model used to develop the Acoustic Technology that is integral to the design and future operations of the USS IDAHO SSN 799.
    </p>
  </>
)

export default DougVetsch
